import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";

// Placeholder food items (can also come from props)
const placeholderItems = ["pizza 🍕", "naan", "ice cream 🍦", "dosa", "biryani"];

const DynamicSearchBar = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        if (!placeholderItems.length) return;

        const interval = setInterval(() => {
            setFade(false); // start fade out
            setTimeout(() => {
                setCurrentIndex((prev) => (prev + 1) % placeholderItems.length);
                setFade(true); // fade in new text
            }, 300); // fade duration
        }, 3000); // change placeholder every 3s

        return () => clearInterval(interval);
    }, []);

    return (
        <Link
            to="explore"
            style={{
                position: "absolute",
                top: "28%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "85%",
                zIndex: 2,
                backgroundColor: "#fff",
                padding: "13px 14px",
                borderRadius: 12,
                display: "flex",
                justifyContent: "flex-start",
                gap: 9,
                alignItems: "center",
                fontSize: 15,
                fontWeight: 500,
                textDecoration: "none",
                color: "#6f6f6f",
                boxShadow: "0 4px 15px rgba(0,0,0,0.15)"
            }}
        >
            <i className="si si-magnifier" style={{fontWeight: 500 }}/>
            <span
                style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: 14.5,
                    transition: "opacity 0.3s ease-in-out",
                    opacity: fade ? 1 : 0
                }}
            >
        {"Search '" + placeholderItems[currentIndex] + "'"}
      </span>
        </Link>
    );
};

export default DynamicSearchBar;